// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5f400f4a","732":"4ce2ecb5","977":"a4337c4a"}[chunkId] + ".chunk.js";
};